// utils/importImages.js

export const importAllImages = (r) => {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  };
  
  // Import all images from the directory
  const images = importAllImages(require.context('../Assets/Images', false, /\.(png|jpe?g|svg)$/));
  
  export default images;
  